export const sizes = Object.freeze({
    null: '',
    xxl: 1440,
    xl: 1280,
    l: 960,
    m: 768,
    s: 600,
    xs: 480,
});
/* Example

        ${media('max', 's')} {
            width: 50%;
        }
        // max-width (600px)

        ${media(null, 's', 'l')} {
            width: 50%;
        }
        // min-width (601px) and max-width(960px)

 */
const media = (type = 'min', breakpoint, breakpoint2) => {
    if (breakpoint2) {
        return `@media (min-width: ${Number(sizes[breakpoint]) + 1}px) and (max-width: ${sizes[breakpoint2]}px)`;
    }
    else {
        return `@media (${type}-width: ${Number(sizes[breakpoint]) + (type === 'min' ? 1 : 0)}px)`;
    }
};
export default media;
